var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#40ba0c;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M611,398.5a14,14,0,1,0-14-14A14,14,0,0,0,611,398.5Z",
    transform: "translate(-597 -370.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M618.08,377.93h-14A1.09,1.09,0,0,0,603,379v9.3a1.07,1.07,0,0,0,.32.77,1.06,1.06,0,0,0,.77.32h2.48l-.06,2.36a.71.71,0,0,0,1.07.4,17.87,17.87,0,0,0,2.88-2.76h7.63a1.06,1.06,0,0,0,.77-.32,1.07,1.07,0,0,0,.32-.77V379a1.09,1.09,0,0,0-1.09-1.09Zm-10.14,6.76a.8.8,0,0,1-.45-.14.75.75,0,0,1-.3-.36.79.79,0,0,1-.05-.48.79.79,0,0,1,.64-.64.87.87,0,0,1,.48,0,.86.86,0,0,1,.37.31.82.82,0,0,1-.69,1.27Zm3.17,0a.86.86,0,0,1-.46-.14.84.84,0,0,1-.35-.84.83.83,0,0,1,.23-.42.76.76,0,0,1,.42-.23.84.84,0,0,1,.84.35.83.83,0,0,1,.14.46.86.86,0,0,1-.24.58.83.83,0,0,1-.58.24Zm3.11,0a.82.82,0,0,1-.76-.51.87.87,0,0,1-.05-.48.84.84,0,0,1,.23-.42.81.81,0,0,1,.42-.22.76.76,0,0,1,.47.05.78.78,0,0,1,.37.3.8.8,0,0,1,.14.45.84.84,0,0,1-.82.83Z",
    transform: "translate(-597 -370.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextMe);
export default __webpack_public_path__ + "static/media/text_me.3ff522640ded687974603426dca1fbec.svg";
export { ForwardRef as ReactComponent };